import { Device } from "@fairfleet/geotab";

/**
 * Attempts to get the license plate field from the given {@link Device}.
 * @param device - The device to get license plate info from.
 * @returns - The license plate info or undefined.
 */
export default function getDeviceLicensePlate(device?: Device): string {
  const deviceRecord = device as Record<string, string> | undefined;
  return deviceRecord?.licensePlate ?? "";
}
